import { createContext } from '../utils/create-context';

export const [TabNavIndicatorProvider, useTabNavIndicatorCtx] = createContext<
  React.RefObject<HTMLDivElement | null>
>('TabNavIndicatorContext');
